var _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowTwoWay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 45,
    viewBox: "-6 -6 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 16,
    fill: "rgba(0, 170, 255, 1)",
    stroke: "#FFF",
    strokeWidth: "2px"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    viewBox: "-6 -6  36",
    d: "M10.1733 6.82246L14.2649 5.72063L13.1733 1.62631L12.0483 3.57487L6.84566 0.571115L6.09566 1.87015L11.2983 4.8739L10.1733 6.82246ZM0.323549 2.86775L1.41513 6.96207L2.54013 5.01352L7.74278 8.01727L8.49278 6.71823L3.29013 3.71448L4.41513 1.76592L0.323549 2.86775Z",
    transform: "scale(1.6) rotate(60, 5, 6)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowTwoWay);
export default __webpack_public_path__ + "static/media/arrow-two-way.9cc3cdda84ea03e6d4e1cfce975e7cc0.svg";
export { ForwardRef as ReactComponent };